import Wrapper from './wrapper';
import {
  IDataPoolCreateParams,
  IDataPoolListParams,
  IDataPoolListResponse,
  IDataPoolUpdateParams,
  IWrapper,
} from './types';
import { IDataPool, IDataPoolRouteConfig } from '../types/my-types';

class DataPool {
  wrapper: IWrapper;

  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  retrieve() {
    return this.wrapper.client.get<IDataPool, IDataPool>(
      `data-pools/${this.wrapper.dataPoolId}/?advanced=true`
    );
  }

  create(data: IDataPoolCreateParams) {
    return this.wrapper.client.post('data-pools/?advanced=true', data);
  }

  update(id: string, data: IDataPoolUpdateParams) {
    return this.wrapper.client.patch(`data-pools/${id}/?advanced=true`, data);
  }

  retrieveRouteConfig(dataPoolId: string) {
    return this.wrapper.client.get<IDataPoolRouteConfig, IDataPoolRouteConfig>(
      `data-pools/${dataPoolId}/route-config?advanced=true`
    );
  }

  updateRouterPrefixApi(id: string, prefix: string) {
    return this.wrapper.client.put(`data-pools/${id}/route-config/?advanced=true`, {
      route_prefix: {
        prefix,
      },
    });
  }

  // FIXME: Type routerConfigSettings
  updateRouterConfig(id: string, routerConfigSettings: any) {
    return this.wrapper.client.put(
      `data-pools/${id}/route-config/?advanced=true`,
      routerConfigSettings
    );
  }

  list(params: IDataPoolListParams) {
    return this.wrapper.client.get<IDataPoolListResponse, IDataPoolListResponse>(`data-pools/`, {
      params,
    });
  }

  updateValidationDismissal(dataPoolId: string, validationId: number, dismissalReason: string | null) {
    return this.wrapper.client.patch(
      `data-pools/${dataPoolId}/validations/${validationId}`,
      { dismissal_reason: dismissalReason }
    );
  }
}

export default DataPool;
